import { CampaignDocument } from '../model/campaign'

// Newest first; entries with a missing or unparsable `created` value sort last.
export const sortCampaignResourcesByCreatedDesc = (items: CampaignDocument[]): CampaignDocument[] =>
  [...items].sort(
    (a, b) =>
      (Date.parse(String(b.created ?? '')) || 0) - (Date.parse(String(a.created ?? '')) || 0)
  )
